import {
    fetchDealerCategories,
    fetchServiceProviderCategories,
} from "@/apis";
import {
    DEALER_DETAILS,
    SERVICE_PROVIDER_DETAILS,
} from "@/_constant";
import type { Category } from "@/types";
import type { ICategoryStrategy, NextAction } from "./ICategoryStrategy";

export type OnboardingCategoryAccessType = "dealer" | "service-provider";

const getCategoryList = (response: any): Category[] => {
    const data = response?.data?.response ?? response?.data;
    if (Array.isArray(data)) return data;
    if (Array.isArray(data?.list)) return data.list;
    if (Array.isArray(data?.categories)) return data.categories;
    return [];
};

export class OnboardingCategoryStrategy implements ICategoryStrategy {
    readonly useUrlDepth = false;
    readonly autoSelectSingleCategory = false;
    private readonly registeredCategoryIds: Set<string>;

    constructor(
        private readonly accessType: OnboardingCategoryAccessType,
        registeredCategoryIds: Iterable<string> = []
    ) {
        this.registeredCategoryIds = new Set(registeredCategoryIds);
    }

    async fetchCategories(): Promise<Category[]> {
        const response = await (this.accessType === "dealer"
            ? fetchDealerCategories()
            : fetchServiceProviderCategories());

        return getCategoryList(response).filter(
            (category) =>
                !this.registeredCategoryIds.has(String(category.id))
        );
    }

    onLeafCategorySelected(category?: Category): NextAction {
        return this.getNextAction(category as Category);
    }

    getNextAction(category: Category): NextAction {
        const detailsRoute =
            this.accessType === "dealer"
                ? DEALER_DETAILS
                : SERVICE_PROVIDER_DETAILS;

        return {
            kind: "navigate",
            to: detailsRoute.replace(
                ":categoryKey",
                encodeURIComponent(category.key)
            ),
        };
    }
}
